//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import comicobject from '../../../script/comicobject'

export default {
  name: "star",
  mixins: [comicobject],
  data() {
    return {
      comic_list: undefined,
      comic_rows: undefined,
      ROW_COUNT: this._g.COMMON_ROW_COUNT,
    }
  },
  created() {
    this.load_comic_star_list({
      start: 0,
      limit: 30,
      cb: this.on_comic_star
    });
  },
  methods: {
    on_comic_star: function (response) {
      console.log("on_comic_star:", response);
      this.comic_list = response.star_list;
      this.comic_rows = this.do_comic_list(this.comic_list, this.ROW_COUNT);
    }
  }
}
